import { getFirestore, collection, query, where, orderBy, getDocs, getDoc, doc } from "firebase/firestore";
import { firebaseApp } from "../../firebase.js"; // adjust based on where you init Firebase

const db = getFirestore(firebaseApp);

const getUserByRef = async (userRef) => {
  if (!userRef) return null;
  const userSnap = await getDoc(userRef);
  return userSnap.exists() ? { id: userSnap.id, ...userSnap.data() } : null;
};

function shuffleArray(array) {
  return array
    .map((value) => ({ value, sort: Math.random() }))
    .sort((a, b) => a.sort - b.sort)
    .map(({ value }) => value);
}

export const getApprovedSellWithUser = async () => {
  const q = query(
    collection(db, "Sell"),
    where("status", "==", "Active"),
    orderBy("timePosted", "desc")
  );
  const snapshot = await getDocs(q);
  const sells = await Promise.all(
    snapshot.docs.map(async (docSnap) => {
      const sellData = docSnap.data();
      const user = await getUserByRef(sellData.sellerUID);
      return {
        id: docSnap.id,
        ...sellData,
        employerUser: user, // add full user data
      };
    })
  );

  return sells;
}

export const getSellById = async (id) => {
  try {
    const docRef = doc(db, "Sell", id);      // <-- Use modular doc() here
    const docSnap = await getDoc(docRef);     // <-- Use getDoc()

    if (!docSnap.exists()) return null;       // <-- call exists() as a method

    const sellData = docSnap.data();
    const user = await getUserByRef(sellData.sellerUID);    
    return {
      id: docSnap.id,
      ...sellData,
      employerUser: user
    };
  } catch (error) {
    console.error("Error fetching rental by ID:", error);
    return null;
  }
};

export const getRandomApprovedSellWithUser = async () => {
  const q = query(
    collection(db, "Sell"),
    where("status", "==", "Active"),
    orderBy("timePosted", "desc")
  );
  const snapshot = await getDocs(q);
  const shuffledDocs = shuffleArray(snapshot.docs).slice(0, 5);

const sells = await Promise.all(
  shuffledDocs.map(async (docSnap) => {
    const sellData = docSnap.data();
    const user = await getUserByRef(sellData.sellerUID);
    return {
      id: docSnap.id,
      ...sellData,
      employerUser: user,
    };
  })
);

  return sells;
}
